var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/load.template.html');

var ThermalView = require('views/load/thermal.view.ts');
var ElectricalView = require('views/load/electrical.view.ts');

var TheView = GenericView.extend({
    el: '#load',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
        this.renderTabsContent();
    },
     events: {
         "click .ui-tabview-nav.load .nav-item": "changeTab"
     },
     changeTab: function(event)
     {
         event.stopPropagation();
         this.$el.find(".ui-tabview-nav.load").find("li.active").removeClass("active");
         $(event.currentTarget).addClass("active");

         this.$el.find(".ui-tabview-panels.load > .show").removeClass("show");
         var id = $(event.currentTarget).data("id");
         $("#" + id).addClass("show");

     },
     renderTabsContent: function() {
         var thermal_view = new ThermalView();
         var electrical_view = new ElectricalView();
     }
});

module.exports= TheView;